import { jsx as _jsx } from "react/jsx-runtime";
import styles from "./PointsProgressBar.module.scss";
export const PointsProgressBar = ({ currentPoints, requiredPoints, hidden }) => {
    const progress = Math.min((currentPoints / requiredPoints) * 100, 100);
    const MAX_PROGRESS = 100;
    if (progress === MAX_PROGRESS || hidden)
        return null;
    return (_jsx("div", { className: styles.pointsProgressBar, "data-testid": "pointsProgressBar", children: _jsx("div", { className: styles.pointsProgressBarFill, style: { width: `${progress}%` }, "data-testid": "pointsProgressBarFill" }) }));
};
//# sourceMappingURL=PointsProgressBar.js.map